import type React from "react";
import type { ReactNode } from "react";

interface Props {
	children: ReactNode;
}

export const ContentContainerWrapper: React.FC<Props> = ({ children }) => {
	return (
		<main className="main-section flex flex-col justify-center items-center">
			{children}
		</main>
	);
};
